import * as React from 'react';
import Typography from '@material-ui/core/Typography';

/**
 * @typedef {Object} TabPanelProps
 * @property {import('react').ReactNode} children
 * @property {*} index
 * @property {*} value
 * @property {*} classes
 */

/**
 * @param {TabPanelProps} props
 */
const TabPanel = props => {
  const { children, value, index, classes, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      classes={classes}
      {...other}
    >
      {value === index && children}
    </Typography>
  );
};

TabPanel.defaultProps = {
  children: undefined
};

export default TabPanel;
